import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import styled from "styled-components";
import Card from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";
import { useSelections } from "../../../context/Selections";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

function DetalhePositivacao({ app, config }) {
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const [selectedValue, setSelectedValue] = useState("");

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Tipo_Det_POS")
        : null;
      setSelectedValue(distributors?.qSelected);
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  const handleChange = (event) => {
    if (event.target.value) {
      app.field("Tipo_Det_POS").selectMatch(event.target.value);
      setSelectedValue(event.target.value);
    }
  };

  return (
    <>
      <FormControl className="container-form-control">
        <RadioGroup
          row
          value={selectedValue}
          onChange={handleChange}
          sx={{ marginLeft: "20px", marginBottom: "16px" }}
        >
          <FormControlLabel
            value="Total Carteira"
            control={
              <Radio
                size="small"
                sx={{
                  color: "#0DA9D5",
                  "&.Mui-checked": {
                    color: "#0DA9D5",
                  },
                }}
              />
            }
            label="Total Carteira"
          />

          <FormControlLabel
            value="Total PDVs Positivados"
            control={
              <Radio
                size="small"
                sx={{
                  color: "#0DA9D5",
                  "&.Mui-checked": {
                    color: "#0DA9D5",
                  },
                }}
              />
            }
            label="Total PDVs Positivados"
          />

          <FormControlLabel
            value="PDVs não Positivados na Carteira"
            control={
              <Radio
                size="small"
                sx={{
                  color: "#0DA9D5",
                  "&.Mui-checked": {
                    color: "#0DA9D5",
                  },
                }}
              />
            }
            label="PDVs não Positivados na Carteira"
          />
        </RadioGroup>
      </FormControl>

      <LayoutCardsWrapper>
        <LayoutCardWrapper>
          <div style={{ width: "100%", height: "90%" }}>
            <Card
              app={app}
              style={{ width: "100%", height: "100%" }}
              exportContainer
              exportTable
              exportTableId="feybUMZ"
            >
              <NativeObject
                app={app}
                style={{ width: "100%", height: "100%" }}
                key="feybUMZ"
                reference={{ id: "feybUMZ" }}
              />
            </Card>
          </div>
        </LayoutCardWrapper>
      </LayoutCardsWrapper>
    </>
  );
}

DetalhePositivacao.defaultProps = {
  app: null,
  config: {},
};

DetalhePositivacao.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DetalhePositivacao;
